import $ from 'jquery';
import 'slick-carousel';

$('.glc-aktuell__slider').each(function () {
    var $slider = $(this);

    $slider.slick({
        autoplay: false,
        infinite: true,
        arrows: true,
        dots: false,
        draggable: true,
        rows: 0,
        prevArrow: '<button class="slick-prev fa-thin fa-arrow-left" title="'+ window.translationStrings.prevSlide +'"></button>',
        nextArrow: '<button class="slick-next fa-thin fa-arrow-right" title="'+ window.translationStrings.nextSlide +'"></button>',
        appendArrows: $('<div>', {class: 'glc-aktuell__arrows'}).insertAfter($slider),
        mobileFirst: true,
        slidesToShow: 1,
        responsive: [
            {
                breakpoint: 767.98,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 1359.98,
                settings: {
                    slidesToShow: 3,
                }
            }
        ]
    });
});

adjustSliderPosition()
$(window).on('resize', function () {
    adjustSliderPosition();
})

function adjustSliderPosition() {
    $('.glc-aktuell').each(function () {
        var $aktuellWrap = $(this);

        if ($aktuellWrap.find('.glc-aktuell__image-overlay').length < 1) {
            $aktuellWrap.find('.glc-aktuell__arrows').addClass('glc-aktuell__arrows--sides');

            const updateArrowPosition = function () {
                const imgHeight = $aktuellWrap.find('.glc-aktuell__image').height();
                const arrowHeight = $aktuellWrap.find('.glc-aktuell__arrows .slick-arrow').height();

                $aktuellWrap.find('.glc-aktuell__arrows').css('top', (imgHeight / 2 - arrowHeight / 2) + 'px');
                window.requestAnimationFrame(updateArrowPosition);
            };

            window.requestAnimationFrame(updateArrowPosition);
        }
    });
}
